import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Short",
  "use": "svg-icon-Short-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg-icon-Short\"><path d=\"M0 5.001V3h16v2.001H0zm0 4v-2h8v2H0zm0 4v-2h16v2H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol